export const propInfo = {
  name: {
    saveSuccess: "Nome della struttura salvato con successo",
    successTitle: "Operazione riuscita",
    saveError: "Impossibile salvare il nome della struttura",
  },
  capacity: {
    saveSuccess: "Capacità salvata con successo",
    saveError: "Impossibile salvare la capacità",
  },
  location: {
    loadError: "Impossibile caricare i dettagli dell'annuncio.",
    appliedBulk: "Posizione applicata a {count} alloggi collegati",
    saveSuccess: "Posizione salvata con successo",
    partialError: "Non è stato possibile aggiornare alcuni alloggi",
    savePropertySuccess: "Posizione della struttura salvata con successo",
    saveError: "Impossibile salvare la posizione della struttura",
    loading: "Caricamento della posizione dell'annuncio…",
    noUnitsTitle: "Questo annuncio non ha ancora unità configurate.",
    noUnitsText: "Crea almeno un'unità per configurare la posizione.",
    bulkNotice: "Questa modifica verrà applicata ai {count} alloggi collegati a {name}.",
  },
  description: {
    saveSuccess: "Descrizione salvata con successo",
    saveError: "Impossibile salvare la descrizione",
    cloneTitleNoun: "descrizione",
    cloneItemNoun: "la descrizione",
  },
};
